// eslint-disable-next-line no-restricted-imports
import {makeStyles} from "@material-ui/core/styles";

export const useStyles = makeStyles({
  fullWidth: {
    width: '100%',
  },
  formGroup: {
    display: 'flex',
    alignItems: 'flex-end',
  },
});
